import React from 'react';
import { observer } from 'mobx-react-lite';
import './PackageNameLabel.less';

interface Props {
    packageName: string;
}

const PackageNameLabel: React.FC<Props> = ({ packageName }) => {
    return <span className="custom-app-document-preview-package-name">{packageName}</span>;
};

export default observer(PackageNameLabel);
